import Http from "./http";

export const getGroupsMembersAPI = (data) => {
  return Http.post("admin/getUsersByGroupId", data);
};
